import styled from '@emotion/styled'

export const Row = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-around;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
